<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 8.5C10.2091 8.5 12 6.70914 12 4.5C12 2.29086 10.2091 0.5 8 0.5C5.79086 0.5 4 2.29086 4 4.5C4 6.70914 5.79086 8.5 8 8.5ZM6.39961 10.1001C3.74864 10.1001 1.59961 12.2492 1.59961 14.9001C1.59961 15.7838 2.31595 16.5001 3.19961 16.5001H12.7996C13.6833 16.5001 14.3996 15.7838 14.3996 14.9001C14.3996 12.2492 12.2506 10.1001 9.59961 10.1001H6.39961Z"
      fill="currentColor"
    />
  </svg>
</template>
